import { inject, InjectionKey } from "@vue/composition-api";

/**
 * 正しい InjectionKey を指定した場合、provide された値を取得する
 */
export const useGlobalState = <T>(key: InjectionKey<T>) => {
  const globalState = inject(key);

  if (!globalState) {
    throw new Error(`${key} is not provided`);
  }

  return globalState;
};
